<span class="group" [ngStyle]="{color: color}">
  <span nz-icon [nzType]="icon2 ? icon2 : icon" class="group_base"></span>
  <span nz-icon [nzType]="icon" class="group_front"></span>
</span>
